import { useEffect, useRef } from 'react';

// execute fn after ms milliseconds
// if ms is null, the timeout is paused
export const useTimeoutFn = (
  fn: (...args: any[]) => void,
  ms: number | null
) => {
  const timeout = useRef<ReturnType<typeof setTimeout>>(null);
  const callback = useRef(fn);

  useEffect(() => {
    if (ms === null) {
      return () => {};
    }
    if (timeout.current) {
      clearTimeout(timeout.current);
    }

    timeout.current = setTimeout(() => {
      callback.current();
    }, ms);

    return () => {
      if (timeout.current) {
        clearTimeout(timeout.current);
      }
    };
  }, [ms]);
};
